import React, { useState, useEffect } from 'react';

import {
    Container as MaterialContainer,
    Grid,
} from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { HeaderContainer, TitleIcon } from 'common/components';
import * as customColumnsSelectors from 'common/modules/customColumns/selectors';

import * as actions from './actions';
import ListItems from './components/ListItems';
import * as selectors from './selectors';

const Container = ({ filterItems, isFetchingItems, items, tableSettings }) => {
    const { t } = useTranslation();
    const [filterData, setFilterData] = useState({
        orderBy: 'created_at',
        page: 0,
        pageSize: 25,
        searchText: '',
        sortBy: 'desc',
        status: 'active',
    });

    useEffect(() => {
        filterItems(filterData);
    }, []);

    return (
        <MaterialContainer maxWidth={false}>
            <HeaderContainer>
                <Grid size="grow">
                    <TitleIcon title={t('Racking', { count: 2 })} />
                </Grid>
            </HeaderContainer>
            <ListItems
                filterData={filterData}
                filterItems={filterItems}
                isFetching={isFetchingItems}
                items={items}
                setFilterData={setFilterData}
                tableSettings={tableSettings}
            />
        </MaterialContainer>
    );
};

Container.propTypes = {
    filterItems: PropTypes.func,
    isFetchingItems: PropTypes.bool,
    items: PropTypes.array,
    tableSettings: PropTypes.array,
};

const mapStateToProps = createStructuredSelector({
    isFetchingItems: selectors.getIsFetchingItems,
    items: selectors.getFetchItemsData,
    tableSettings: customColumnsSelectors.getTableSettingsData,
});

const mapDispatchToProps = (dispatch) => ({
    filterItems: (filterData) => dispatch(actions.filterItems(filterData)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Container);
